import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { NoteViewModel, SatelliteViewModel } from '@/app/proxy/proxies';
import { SharedModule } from '@/app/shared/shared.module';
import { CropHealthNoteItemComponent } from '../crop-health-note-item/crop-health-note-item.component';
import { CropHealthService } from '../../../../services/crop-health.service';

@Component({
  selector: 'app-crop-health-note-list',
  imports: [SharedModule, CropHealthNoteItemComponent],
  templateUrl: './crop-health-note-list.component.html',
  styleUrl: './crop-health-note-list.component.less',
})
export class CropHealthNoteListComponent implements OnInit {
  @Input() loading = true;
  @Input() selectedDay: SatelliteViewModel;
  
  @Output() readonly addModeChangeEvent = new EventEmitter<boolean>();
  @Output() readonly seeAllNoteChangeEvent = new EventEmitter<boolean>();
  @Output() readonly getAllNotesEvent = new EventEmitter();
  @Output() readonly viewNoteEvent = new EventEmitter();
  
  notes: NoteViewModel[] = [];
  maxNotesToShow = 2;
  constructor(public cropHealthService: CropHealthService) {}

  ngOnInit(): void {
    this.cropHealthService.notes$.subscribe(res => {
      this.notes = res;
      this.calculateMaxNotesToShow();
    });
  }

  private calculateMaxNotesToShow(): void {
    if (!this.notes || this.notes.length === 0) {
      this.maxNotesToShow = 2;
      return;
    }

    // Notes are already sorted DESC by date (newest first)
    const sortedNotes = [...this.notes];
    const hasImage = (note: NoteViewModel): boolean => {
      return note.fileList && note.fileList.length > 0;
    };

    // Maximize the number of notes shown
    // Images take more space, so we show fewer notes when images are present

    // Show 4 if: 4+ notes exist AND none of the first 4 have images (no images = can fit more)
    if (sortedNotes.length >= 4) {
      const firstFourHaveNoImage = sortedNotes.slice(0, 4).every(note => !hasImage(note));
      if (firstFourHaveNoImage) {
        this.maxNotesToShow = 4;
        return;
      }
    }

    // Show 3 if: 3+ notes exist AND we can fit 3 (not at least 2 of first 3 have images)
    if (sortedNotes.length >= 3) {
      const firstThree = sortedNotes.slice(0, 3);
      const imagesCount = firstThree.filter(note => hasImage(note)).length;
      
      // If at least 2 of the first 3 have images, only show 2 (too much space taken)
      if (imagesCount >= 2) {
        this.maxNotesToShow = 2;
        return;
      }
      
      // Otherwise, we can show 3
      this.maxNotesToShow = 3;
      return;
    }

    // Show 2 if: 2+ notes exist (minimum)
    if (sortedNotes.length >= 2) {
      this.maxNotesToShow = 2;
      return;
    }

    // Show 1 if: only 1 note exists
    this.maxNotesToShow = 1;
  }
}
